import {
  inject,
  InjectionKey,
  provide,
  readonly,
} from '@nuxtjs/composition-api'
import { useBrand } from '../useBrand'
import { injectProductList } from './useProductList'
import {
  FilterFields,
  ListType,
  ProductListMode,
  ProductListOptions,
} from '~/types/product'

export const useProductBrand = () => {
  const base = injectProductList()
  const { brand, getByUrl } = useBrand()

  const initialize = async (url: string) => {
    await base.ensureOptions(() => {
      const option: ProductListOptions = {
        listType: ListType.Brand,
        prefilters: [
          {
            field: FilterFields.BrandUrl,
            value: url,
          },
        ],
        brandMode: ProductListMode.Navigation,
      }
      return option
    })
    await getByUrl(url)
    await base.loadProducts(true)
  }

  return {
    brand: readonly(brand),
    ...base,
    initialize,
  }
}

// provide productBrand
const ProductBrandProviderKey: InjectionKey<
  ReturnType<typeof useProductBrand>
> = Symbol('Provider:ProductBrand')

export const provideProductBrand = () => {
  const result = useProductBrand()

  provide(ProductBrandProviderKey, result)
}

// inject productBrand
export const injectProductBrand = () => {
  const result = inject(ProductBrandProviderKey)
  if (!result) {
    throw new Error('product brand provider not set')
  }

  return result
}
